module.exports = __webpack_public_path__ + "static/example-01-random-5233c8c154841904f3260dc326dad283.png";